import React from 'react';
import { connect } from 'react-redux';
import { Utils } from '../../utilSMB/utils';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import ReactHtmlParser, { convertNodeToElement } from 'react-html-parser';

import { TileletCarousel } from '@vds/tiles';
import { TextLinkCaret } from '@vds/buttons';
import { redirectTo } from './../../actionSMB/redirection';

class Banner extends React.PureComponent {
  // constructor(props) {
  //   super(props);
  //   const queryString = window.location.search;
  //   this.newBanner = queryString.indexOf('newbanner') > -1;
  // }

  render() {
    let bannerList = [];
    const bannerListDesc = [];
    // var settings = {
    //   dots: true,
    //   infinite: true,
    //   speed: 300,
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   arrows: true,
    //   className: 'banner',
    //   autoplay: true,
    //   autoplaySpeed: 10000,
    //   pauseOnHover: true,
    //   responsive: [
    //     {
    //       breakpoint: 1024,
    //       settings: {
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //         swipeToSlide: true,
    //       },
    //     },
    //   ],
    // };
    const options = {
      decodeEntities: true,
      transform,
    };
    function transform(node, index) {
      if (node.type === 'tag' && node.name === 'img') {
        let path = node.attribs.src;
        node.attribs.style = 'width:430px; height:auto';
        // node.attribs.src = Utils.getDomainUrl() + path;
        node.attribs.src = Utils.getImagePath(path);
        return convertNodeToElement(node, index, transform);
      }
      if (node.type === 'tag' && node.name === 'a') {
        node.attribs['tabIndex'] = '-1';
      }
    }

    if (this.props.bannerValue && this.props.bannerValue.bannerList) {
      this.props.bannerValue.bannerList.map((bannerExpItems, index) => {
        bannerList.push(ReactHtmlParser(bannerExpItems.description, options));

        let sliderLink1 = bannerExpItems.description.split('href=');
        let sliderLink2 = sliderLink1[1].split('aria-label');
        let sliderLink3 = sliderLink2[0].split('"');
        let sliderLink = sliderLink3[1];

        bannerListDesc.push({
          title: {
            children: ReactHtmlParser(bannerExpItems.description, options),
          },
          id: `banner_carousel${index+1}`,
          key: index,
          backgroundColor: 'white',
          showBorder: true,
          onClick: () => {redirectTo(sliderLink, this.props.dispatch)},
        });
        return bannerList;
      });
    }

    return (
      <React.Fragment>
        <div className="bg-grey-5">
          <div className="relative hero-carousel-wraper">
            <div className="row hero-carousel" id="hero-carousel-slider" style={{ height: '560px' }}>
              {/* {!this.newBanner ? <Slider {...settings}>{bannerList}</Slider> : ''} */}

              {/* used vds tilelet carousel  */}
              {bannerListDesc.length > 0 ? (
                <TileletCarousel
                  layout="1UP"
                  gutter="24px"
                  peek="none"
                  paginationFill="light"
                  paginationInset="12px"
                  paginationDisplay={'persistent'}
                  aspectRatio="2:1"
                  data={bannerListDesc}
                />
              ) : (
                ''
              )}
            </div>

            {/* <li class="carousel_item" data-carousel-product>
                            <div class="row margin-vert-zero">
                                <div class="tiny-11 small-10 medium-6 columns tiny-margin-top-small small-margin-top-zero medium-margin-horiz-xlarge padding-vert-small large-padding-left-zero">
                                    <h1 class="small tiny-margin-horiz-tiny medium-margin-horiz-small">High–quality sound you can enjoy day and night.</h1>
                                    <div class="text-large margin-bottom-small show-for-medium-up">Experience next–level noise cancellation with <b>Beats Studio3 Wireless Over-Ear Headphones</b>.
                                          </div>
                                    <br /><br />
                                    <div class="ribbon-container bg-black">
                                        <div class="text-center text-white margin-left-small margin-right-small padding-top-tiny padding-bottom-tiny text-large">
                                            <b>ON SALE NOW!&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b>Get 25% off while supplies last.
                                                   </div>
                                    </div>
                                    <br /><br />
                                    <a class="button cta-text block small-text-xlarge medium-text-xxlarge bold" href="/smallbusiness/accessories/beats-studio3-wireless-over-ear-headphone/">Shop now</a>
                                </div>
                                <div class="tiny-10 small-10 medium-6 columns">
                                    <a href="/smallbusiness/accessories/beats-studio3-wireless-over-ear-headphone/">
                                        <div class="tiny-margin-horiz-medium medium-margin-horiz-xlarge tiny-padding-bottom-large bleed-img">
                                            <img src="/smallbusiness/accessories/media/images-accessories/vzw/MQ562LLA_H.png" class="show-for-medium-up padding-left-medium" alt="Photo of the women using Beats Studio3 Headphones">
                                                <img style="width:290px;" src="/smallbusiness/accessories/media/images-accessories/vzw/MQ562LLA_H.png" class="show-for-small-only" alt="Photo of the women using Beats Studio3 Headphones">
                                                    <img style="width:210px;" src="/smallbusiness/accessories/media/images-accessories/vzw/MQ562LLA_H.png" class="show-for-tiny-only" alt="Photo of the women using Beats Studio3 Headphones"> 
                                                                 </div> 
                                                                 </a> 
                                                            </div>
                                        </div>
                            </li> */}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default connect()(Banner);
